<template>

    <div class="c-form_tags">
        <div class="c-form_tags__add">

            <form-select
                v-model="newTag"
                @input="error = ''"
                :options="options"
                :ajax-url="ajaxUrl"
                :format-item="formatItem"
                :label="label"
                btn="green"
                btn-label="Dodaj"
                @click="addTag"
                :error="error">
            </form-select>

<!--            <form-input-->
<!--                :label="label"-->
<!--                v-model="newTag"-->
<!--                class="c-form_tags__add-input"-->
<!--                btn="green"-->
<!--                btnLabel="Dodaj"-->
<!--                @input="error = ''"-->
<!--                @click="addTag"-->
<!--                :error="error"-->
<!--                :speech-to-text="speechToText">-->
<!--            </form-input>-->
        </div>

        <ul class="c-form_tags__list">
            <form-tag
                v-for="tag in tags"
                :key="tag"
                :title="tag"
                :animate="fadeInTag"
                @delete="deleteTag">
            </form-tag>
        </ul>
    </div>

</template>


<script>

import FormSelect from './FormSelect'
import FormTag from './FormTag'

export default {

    name: 'FormTagSelectInput',

    props: {
        value: Array,
        label: String,
        options: Array,
        ajaxUrl: String,
        formatItem: Function,
    },

    data() {
        return {
            newTag: '',
            tags: this.value,
            fadeInTag: false,
            error: ''
        }
    },

    methods: {
        deleteTag(tag) {
            var tagId = this.tags.indexOf(tag)
            this.tags.splice(tagId, 1)
        },
        addTag(tag) {
            if (tag !== '' && !this.tagExist(tag)) {
                this.fadeInTag = true
                this.tags.push(tag.trim())
                this.newTag = ''
                this.$emit('change')
            }
        },
        tagExist(newTag) {
            newTag = newTag.trim().toLowerCase()
            let dup = this.tags.filter((tag) => {
                return (tag.toLowerCase() === newTag)
            }).length

            if (dup > 0) {
                this.error = 'Taki element już istnieje'
                return true
            }

            return false

        }
    },

    watch: {
        value(value) {
            this.tags = value
        },
        tags(value) {
            this.$emit('input', value)
        }
    },

    components: {
        FormSelect,
        FormTag,
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-form_tags {
    margin-bottom: 1rem;

    &__add {
        display: flex;
        width: 100%;
        max-width: 450px;

        &-input {
            width: 100%;
        }
        &-btn {
            margin-left: 0.7rem;

            @include bp(490px) {
                text-indent: -9999px;
                background-image: url('#{$icons}/plus.svg');
                background-position: center;
                background-size: 18px;
                background-repeat: no-repeat;
                padding: 0;
                flex-shrink: 0;
                width: 40px;
                margin-left: 0px;
                border-radius: 0 5px 5px 0;

                &:hover {
                    background-color: $c-primary;
                }
            }
        }
    }
    &__list {
        margin: 1rem -5px;
        width: 100%;
    }
}

</style>
